import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { footer } from "./ListNav.module.scss";

const ListNavFooter = ({ className, ...props }) => (
  <footer className={classNames(footer, className)} {...props} />
);

ListNavFooter.propTypes = {
  className: PropTypes.string
};

ListNavFooter.defaultProps = {
  className: ""
};

export default ListNavFooter;
